exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-09d65745] .el-upload__tip{margin:0;line-height:14px;color:#939696}[data-v-09d65745] .el-form-item__content{line-height:24px}[data-v-09d65745] .el-dialog__body{padding-top:0;height:calc(100% - 60px)}", ""]);

// exports
